import {useCallback, useState} from "react";

const useHttp = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();

    const sendRequest = useCallback(async (requestConfig, responseCallback) => {
        setIsLoading(true);
        setError(undefined);
        try {
            console.log(`REQUEST : ${JSON.stringify(requestConfig.body)}`)
            const token = localStorage.getItem('ibill_access_token');
            const headers= requestConfig.headers ? requestConfig.headers : {}
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            const response = await fetch(
                requestConfig.url, {
                    method: requestConfig.method ? requestConfig.method : 'GET',
                    headers,
                    body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
                }
            );
            const jsonResp = await response.json();
            console.log(`${JSON.stringify(jsonResp)}`)
            if (!response.ok) {
                throw Error(`Something went wrong. Status Code - ${response.status}`);
            } else if (jsonResp.status === 'OK' || jsonResp.status.code === 200) {
                responseCallback(jsonResp.data);
            } else {
                if(jsonResp.data.errorMessage === undefined) {
                    throw Error(`Error: Code - ${jsonResp.status}, Message - ${jsonResp.data}`);
                }
                throw Error(`Error: Code - ${jsonResp.status}, Message - ${jsonResp.data.errorMessage}`);
            }
        } catch (err) {
            setError(err.message || 'Something went wrong!');
        }
        setIsLoading(false);
    }, []);

    const uploadFile = useCallback(async (requestConfig, responseCallback, errorCallback) => {
        setIsLoading(true);
        setError(undefined);
        try {
            const token = localStorage.getItem('ibill_access_token');
            const headers= requestConfig.headers ? requestConfig.headers : {}
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            const formData = new FormData();
            formData.append('file', requestConfig.file);
            const response = await fetch(
                requestConfig.url, {
                    method: 'POST',
                    headers,
                    body: formData,
                }
            );
            const jsonResp = await response.json();
            console.log(`${JSON.stringify(jsonResp)}`)
            if (!response.ok) {
                throw Error(`Something went wrong. Status Code - ${response.status}`);
            } else if (jsonResp.status === 'OK' || jsonResp.status.code === 200) {
                responseCallback(jsonResp.data);
            } else {
                errorCallback(jsonResp.data);
            }
        } catch (err) {
            setError(err.message || 'Something went wrong!');
        }
        setIsLoading(false);
    }, []);

    return {
        isLoading,
        error,
        sendRequest,
        uploadFile
    };
}

export default useHttp;